module.exports = __webpack_public_path__ + "static/img/Taxcellent.fbe905e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/Taxcellent.png
// module id = yXEM
// module chunks = 34